import React, { useEffect, useState } from "react";
import HomeTable from "../../components/table/HomeTable";
import { SectionRow } from "./../../layouts/sections/index";
import StatCard from "./../../components/cards/statCard";
import {
	STAT_ACCENT_COLORS,
	STAT_ICON_PATHS,
	setStakeholderTypes,
	STAKEHOLDERS,
} from "./../../app/constants";
import { useParams } from "react-router-dom";
import { Button, Tooltip } from "@mui/material";
import { navigateNewTab, navigateSelf } from "../../app/router/routerManager";
import { CERTIFICATION_BODY_ROUTES, FINAL_COMMENTS_ROUTES } from "../../app/router/routes";
import { deleteStepper } from "./../../components/stepper/dynamicStepper";

import { setApplicationStage, showViewIcon } from "../../components/table/tableHelpers";
import {
	getMapTableCounts,
	getMapTableRecords,
	getTableCounts,
	getTableRecords,
} from "./../../app/api/NOCU/tableAPI";

import { setStakeholderType } from "../../app/api/NOCU/helpers/applicationApiHelpers";
import { getUserId } from "./../../app/api/NOCU/helpers/applicationApiHelpers";
import { getMapTableData, getTableData } from "./dataManipulation";
import LoaderComponent from "../../components/Loader/LoaderComponent";
import { deleteIsRenewal, setIsRenewal } from "../../components/navbar/helpers";

const FinalCommentsHome = () => {
	const { id } = useParams();
	const [records, setRecords] = useState();
	const [counts, setCounts] = useState({
		pendingCount: 0,
		approvedCount: 0,
		rejectedCount: 0,
		resubmissionCount: 0,
	});
	const [selectedCount, setSelectedCount] = useState();
	const [selectedTitle, setSelectedTitle] = useState("New Requests");
	const [isLoading, setIsLoading] = useState(true);
	const [tableCount, setTableCount] = useState();
	const [res, setRes] = useState();

	const tableHeaders = [
		"Name",
		<Tooltip title={<div className='p-2 text-sm'>System Generated Mapping Number</div>}>
			<div>System No.</div>
		</Tooltip>,
		"Application No.",
		"Contact Person",
		"Date & Time",
		"Application Type",
	];

	let filters = [
		{ key: "PENDING", value: "PENDING" },
		{ key: "SUCCESS", value: "SUCCESS" },
		{ key: "SUSPENDED", value: "SUSPENDED" },
		{ key: "APPROVED", value: "APPROVED" },
		{ key: "REJECTED", value: "REJECTED" },
	];
	let sorting = [
		{ key: "Acceding", value: true },
		{ key: "Descending", value: false },
	];
	const [selectedStatCard, setSelectedStatCard] = useState(1);
	const [params, setParams] = useState({
		page: 0,
		size: 5,
		applicationNumber: "",
		stakeholderType: "ALL",
		applicationStage: "FINAL_COMMENT",
		status: "",
		officerId: getUserId(),
		isAscending: true,
	});

	useEffect(() => {
		setSelectedStatCard(parseInt(id));
		if (parseInt(id) === 1) {
			setParams({ ...params, status: "PENDING" });
			setSelectedCount(counts.pendingCount);
			setSelectedTitle("Pending Requests");
		} else if (parseInt(id) === 2) {
			setParams({ ...params, status: "RESUBMIT" });
			setSelectedCount(counts.resubmissionCount);
			setSelectedTitle("Resubmitted Requests");
		} else if (parseInt(id) === 3) {
			setParams({ ...params, status: "APPROVED", isAscending: false });
			setSelectedCount(counts.approvedCount);
			setSelectedTitle("Completed Requests");
		} else if (parseInt(id) === 4) {
			setParams({ ...params, status: "REJECTED" });
			setSelectedCount(counts.rejectedCount);
			setSelectedTitle("Rejected Requests");
		}
	}, [id]);
	const handleFilter = (filter) => {
		setParams({ ...params, status: filter });
	};

	const handleStakeHolderType = (filter) => {
		setParams({ ...params, stakeholderType: filter });
	};

	const handleSearchById = (id) => {
		setParams({ ...params, applicationNumber: id });
	};

	const handleSorting = (isAscending) => {
		setParams({ ...params, isAscending: isAscending });
	};
	const handlePage = (page) => {
		setParams({ ...params, page: page });
	};
	const handleSize = (size) => {
		setParams({ ...params, size: size });
	};

	const viewFunction = (index) => {
		//setStakeholderType(res.mappedApplicationList[index]?.stakeholderType);
		//console.log("stakeholderType", res.mappedApplicationList[index]?.stakeholderType, index)
		setIsRenewal(res.mappedApplicationList[index]?.isRenewal);
		setApplicationStage(params.applicationStage);
		navigateSelf(FINAL_COMMENTS_ROUTES.REVIEW);
	};
	const historyFunction = (index) => {
		console.log("Index Of record=================>", index);
	};

	useEffect(() => {
		deleteIsRenewal();
		const cParams = {
			officerId: getUserId(),
			stakeholderType: params.stakeholderType,
			applicationNumber: params.applicationNumber,
			applicationStage: "FINAL_COMMENT",
		};
		setStakeholderType(params.stakeholderType);
		getMapTableCounts(cParams).then((res) => {
			setCounts(res);
		});
	}, []);

	useEffect(() => {
		!!!selectedCount && setSelectedCount(counts.pendingCount);
	}, [counts]);

	useEffect(() => {
		console.log("Params ====>", params);
		if (params.status && params.status !== "") {
			getMapTableRecords(params)
				.then((res) => {
					console.log("Res ======> ", getMapTableData(res.data));
					setRecords(getMapTableData(res.data));
					setTableCount(res?.data.count);
					setRes(res.data);
					setIsLoading(false);
				})
				.then((e) => console.log(e));
		}
	}, [params]);

	return (
		<div>
			<LoaderComponent isOpen={isLoading} />
			<SectionRow className='mt-0'>
				<span className='overViewTitle'>Tech Committee Recommendations</span>
			</SectionRow>
			<SectionRow className='w-full overflow-x-auto mb-5 customScrollBar'>
				<SectionRow className='w-full !min-w-max mb-2 justify-center items-center'>
					{/* <StatCard
						value={counts.pendingCount}
						text={"New Request"}
						image={STAT_ICON_PATHS.stat_new_req}
						accent={STAT_ACCENT_COLORS.bluishGray}
						handleStatCard={() => {}}
						num={1}
						selected={selectedStatCard}
						setSelectStatCard={setSelectedStatCard}
					/>
					<StatCard
						value={counts.resubmissionCount}
						text={"Resubmit Requests"}
						image={STAT_ICON_PATHS.stat_cancelation}
						accent={STAT_ACCENT_COLORS.orange}
						handleStatCard={() => {}}
						num={2}
						selected={selectedStatCard}
						setSelectStatCard={setSelectedStatCard}
					/>
					<StatCard
						value={counts.approvedCount}
						text={"Completed Requests"}
						image={STAT_ICON_PATHS.stat_checkMark}
						accent={STAT_ACCENT_COLORS.lightGreen}
						handleStatCard={() => {}}
						num={3}
						selected={selectedStatCard}
						setSelectStatCard={setSelectedStatCard}
					/>
					<StatCard
						value={counts.rejectedCount}
						text={"Rejected Requests"}
						image={STAT_ICON_PATHS.stat_deleteMark}
						accent={STAT_ACCENT_COLORS.red}
						handleStatCard={() => {}}
						num={4}
						selected={selectedStatCard}
						setSelectStatCard={setSelectedStatCard}
					/> */}
					<StatCard
						value={counts ? counts.pendingCount : 0}
						text={"Tech Committee Recommendations"}
						image={STAT_ICON_PATHS.stat_duplication}
						accent={STAT_ACCENT_COLORS.blue}
						handleStatCard={() => {}}
						num={1}
						selected={selectedStatCard}
						setSelectStatCard={setSelectedStatCard}
					/>
					{/* <StatCard
						value={20}
						text={"Pending SLAAB Requests"}
						image={STAT_ICON_PATHS.stat_resubmit}
						accent={STAT_ACCENT_COLORS.yellow}
						handleStatCard={() => {}}
						num={1}
						selected={selectedStatCard}
						setSelectStatCard={setSelectedStatCard}
					/> */}
					<StatCard
						value={counts ? counts.approvedCount : 0}
						text={"Completed Recommendations for Technical Committee"}
						image={STAT_ICON_PATHS.stat_checkMark}
						accent={STAT_ACCENT_COLORS.lightGreen}
						handleStatCard={() => {}}
						num={3}
						selected={selectedStatCard}
						setSelectStatCard={setSelectedStatCard}
					/>

					{/* <StatCard
						value={12}
						text={"Pending Field Visit"}
						image={STAT_ICON_PATHS.stat_upload_verification}
						accent={STAT_ACCENT_COLORS.darkGreen}
						handleStatCard={() => {}}
						num={1}
						selected={selectedStatCard}
						setSelectStatCard={setSelectedStatCard}
					/>
					<StatCard
						value={30}
						text={"Completed Field Visit"}
						image={STAT_ICON_PATHS.stat_checkMark}
						accent={STAT_ACCENT_COLORS.lightGreen}
						handleStatCard={() => {}}
						num={2}
						selected={selectedStatCard}
						setSelectStatCard={setSelectedStatCard}
					/> */}
				</SectionRow>
			</SectionRow>
			<HomeTable
				useMappedApplicationNumber
				applicationKey={1}
				columns={tableHeaders}
				// tableTitle={selectedTitle}
				rows={records}
				handleSearchById={handleSearchById}
				view={showViewIcon(["1"], id) ? viewFunction : null}
				history={historyFunction}
				filters={STAKEHOLDERS}
				setFilter={handleStakeHolderType}
				// sort={sorting}
				handleSort={handleSorting}
				handleSize={handleSize}
				count={tableCount}
				page={params.page}
				size={params.size}
				handlePage={handlePage}
				filterTitle='Stakeholder'
			/>
		</div>
	);
};

export default FinalCommentsHome;
